import Cookies from 'js-cookie';
import actions from './actions';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const login = () => {
  return async dispatch => {
    try {
      dispatch(loginBegin());
      return dispatch(loginSuccess(true));
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = () => {
  return async dispatch => {
    try {
      // const { origin, pathname, search } = document.location;
      // const current = encodeURIComponent(pathname + search);
      // console.log(origin + '/login?redirect=' + current);
      // return;
      console.log(';logout')
      dispatch(logoutBegin());
      Cookies.remove(process.env.REACT_APP_TOKEN_KEY, { domain: process.env.REACT_APP_DOMAIN })
      sessionStorage.clear();
      dispatch(logoutSuccess(null));
      // window.location.replace(origin + '/login?redirect=' + current);
    } catch (err) {
      console.log('err', err)
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut };
